// extracted by mini-css-extract-plugin
export default {"toggle":"Qhlm_5","underline":"FagoIm","active":"tehPfI","toggleLabel":"Un99gg","menuToggleIcon":"S0Ik4l","arrowIcon":"XHSap8"};